import type { VoidFunctionComponent } from 'react';

import { get } from '../../../redux/api';
import { selectOptionFactory } from '../../../utils';
import { FormLabel } from '../../generic';
import AsyncSelect from '../../generic/Select/AsyncSelect';
import type { ProjectsResponse } from '../../../../shared/projectsV2';

const ProjectNameFilters: VoidFunctionComponent<{ projectName: string; setFilters: (...args: unknown[]) => void }> = ({
  projectName,
  setFilters,
}) => {
  return (
    <div className="width-full" data-test-id="package-inventory-filters--project-name">
      <FormLabel label="Project Name">
        <AsyncSelect
          isClearable
          defaultOptions
          cacheOptions
          value={projectName ? selectOptionFactory(projectName) : null}
          placeholder="Select a project name..."
          loadOptions={async (search) => {
            let url = '/api/v2/projects?count=10&sort=title_asc';
            if (search) {
              url = `${url}&title=${search}`;
            }
            const { data } = await get<ProjectsResponse>(url, true);
            if (!data) {
              return [];
            }

            return data.projects.map((project) => selectOptionFactory(project.title));
          }}
          onChange={(selectedOption: { value: string; label: string } | null) => {
            if (!selectedOption) {
              setFilters({
                projectName: null,
              });
            } else {
              setFilters({
                projectName: selectedOption.value,
              });
            }
          }}
        />
      </FormLabel>
    </div>
  );
};

export default ProjectNameFilters;
